import { ProductGallery } from '~/types/product/ProductGallery';
import config from '~/config';

export const ZOOM_ACTIONS = {
  INCREASE: 'increase',
  DECREASE: 'decrease',
  RESET: 'reset',
} as const;

export type ZoomActions = ValueOf<typeof ZOOM_ACTIONS>

export const PRODUCT_GALLERY: ProductGallery = {
  IMAGE_HEIGHT_DESKTOP: 500,
  IMAGE_HEIGHT_MOBILE: 250,
  VIDEO_HEIGHT: 350,
  VIDEO_WIDTH: 500,
  THUMBNAIL_HEIGHT: 200,
  THUMBNAIL_WIDTH: 200,
  THUMBNAIL_CAROUSEL_HEIGHT: 200,
  GALLERY_VIDEO_HEIGHT: 512,
  GALLERY_360_IMAGE_PATH_TEMPLATE: config.IMAGES_360_URL,
  GALLERY_360_IMAGE_CONTENT_HEIGHT_OFFSET: 300,
};
